import HTTP_GESCOM  from '@/api//HTTP_GESCOM';
import gestionErreur from '@/services/general/gestionErreur';
import produitFaceForRecomServerTableDataTransformer from '@/services/produit/produitFaceForRecomServerTableDataTransformer';

const BASE_URL_PRODUIT = 'gescom/Produit';
const BASE_URL_PRODUIT_FACE = 'gescom/ProduitFace';
const BASE_URL_PRODUIT_LOCATION = 'gescom/ProduitLocation';
const BASE_URL_PRODUIT_FACE_FOR_RECOM_DEVIS = 'gescom/ProduitFaceForRecommandationDevisView';

export async function getProduitFaceLc(id) {
  const response = await HTTP_GESCOM.get(`${BASE_URL_PRODUIT_FACE}/GetAsync`, { params: { id } });
  return response;
}

export async function createAllProduitFaceLcAsync(items) {
  const response = await HTTP_GESCOM.post(`${BASE_URL_PRODUIT_FACE}/CreateAllAsync`, items);
  return response;
}

export async function updateProduitFaceLcAsync(data) {
  const response = await HTTP_GESCOM.put(`${BASE_URL_PRODUIT_FACE}/UpdateAsync`, data);
  return response;
}

export async function GetAllProduitFaceForRecom(query) {
  const payload = produitFaceForRecomServerTableDataTransformer(query);
  const response = await HTTP_GESCOM.post(`${BASE_URL_PRODUIT_FACE_FOR_RECOM_DEVIS}/PGetAllAsync`, payload);
  return response;
}

export async function getAllProduits(query) {
  const response = await HTTP_GESCOM.post(`${BASE_URL_PRODUIT}/PGetAllAsync`, query);
  return response;
}

export async function getReferencesProduitFace(refs) {
  try {
    const url = `${BASE_URL_PRODUIT_FACE}/PGetMaxRefsProduitFaceAsync`;
    const response = (await HTTP_GESCOM.post(url, { refs } )).data.result;
    return response;
  } catch (e) {
    gestionErreur('Erreur lors de la récupération de la référence du produit face', e);
    throw e;
  }
}

export async function getAllProduitLocations(query) {
  try {
    return await HTTP_GESCOM.post(`${BASE_URL_PRODUIT_LOCATION}/PGetAllAsync`, query);
  } catch (e) {
    gestionErreur('Erreur lors de la récupération des produits Locations defaults', e);
    throw e;
  }
}
